import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `DateTime` scalar type represents a date and time in the UTC
	 * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
	 * string, including UTC timezone ("Z"). The parsed date and time string will
	 * be converted to UTC if there is an offset.
	 */
	DateTime: { input: string; output: string };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values parsed by the `Decimal` library. The Decimal appears in a JSON
	 * response as a string to preserve precision.
	 */
	Decimal: { input: string; output: string };
};

export type AcceptInvitationInput = {
	password: Scalars['String']['input'];
	passwordConfirmation: Scalars['String']['input'];
};

export type AcceptInvitationPayload = {
	__typename?: 'AcceptInvitationPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type AccessToken = {
	__typename?: 'AccessToken';
	expiresAt: Scalars['DateTime']['output'];
	/** Bearer token for authorization header. */
	jwt: Scalars['String']['output'];
};

/** The action failed due to an unexpected reason. */
export type ActionFailed = {
	__typename?: 'ActionFailed';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** The action was not allowed for a given reason. */
export type InvalidAction = {
	__typename?: 'InvalidAction';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

export type InvalidCredentials = {
	__typename?: 'InvalidCredentials';
	message: Scalars['String']['output'];
};

/** Provided input is not valid. */
export type InvalidInput = {
	__typename?: 'InvalidInput';
	/** Validation context. */
	context: Array<Maybe<InvalidInputContext>>;
	/** Invalid input field's name. */
	field: Scalars['String']['output'];
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Parameter taken into consideration for the validation. */
export type InvalidInputContext = {
	__typename?: 'InvalidInputContext';
	key: Scalars['String']['output'];
	value?: Maybe<Scalars['String']['output']>;
};

export type InviteUserInput = {
	invitedUserEmail: Scalars['String']['input'];
};

export type InviteUserPayload = {
	__typename?: 'InviteUserPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

/** Common errors for any mutation. */
export type MutationError = ActionFailed | InvalidAction | InvalidInput;

/** Common errors for any mutation that has no input. */
export type MutationWithoutInputError = ActionFailed | InvalidAction;

export type RecoverPasswordInput = {
	email: Scalars['String']['input'];
	latitude: Scalars['Decimal']['input'];
	longitude: Scalars['Decimal']['input'];
};

export type RecoverPasswordPayload = {
	__typename?: 'RecoverPasswordPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	acceptInvitation?: Maybe<AcceptInvitationPayload>;
	inviteUser?: Maybe<InviteUserPayload>;
	recoverPassword?: Maybe<RecoverPasswordPayload>;
	signIn?: Maybe<SignInPayload>;
	signOut?: Maybe<SignOutPayload>;
	updatePassword?: Maybe<UpdatePasswordPayload>;
};

export type RootMutationTypeAcceptInvitationArgs = {
	input: AcceptInvitationInput;
};

export type RootMutationTypeInviteUserArgs = {
	input: InviteUserInput;
};

export type RootMutationTypeRecoverPasswordArgs = {
	input: RecoverPasswordInput;
};

export type RootMutationTypeSignInArgs = {
	input: SignInInput;
};

export type RootMutationTypeUpdatePasswordArgs = {
	input: UpdatePasswordInput;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	apiVersion?: Maybe<Scalars['String']['output']>;
};

export type SignInError = ActionFailed | InvalidAction | InvalidCredentials | InvalidInput;

export type SignInInput = {
	email: Scalars['String']['input'];
	latitude: Scalars['Decimal']['input'];
	longitude: Scalars['Decimal']['input'];
	password: Scalars['String']['input'];
};

export type SignInPayload = {
	__typename?: 'SignInPayload';
	mutationErrors: Array<Maybe<SignInError>>;
	result?: Maybe<AccessToken>;
	successful: Scalars['Boolean']['output'];
};

export type SignOutPayload = {
	__typename?: 'SignOutPayload';
	mutationErrors: Array<Maybe<MutationWithoutInputError>>;
	successful: Scalars['Boolean']['output'];
};

export type UpdatePasswordInput = {
	password: Scalars['String']['input'];
	passwordConfirmation: Scalars['String']['input'];
};

export type UpdatePasswordPayload = {
	__typename?: 'UpdatePasswordPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type SignInMutationVariables = Exact<{
	input: SignInInput;
}>;

export type SignInMutation = {
	__typename?: 'RootMutationType';
	signIn?: {
		__typename?: 'SignInPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| { __typename: 'InvalidCredentials'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
		result?: { __typename?: 'AccessToken'; jwt: string; expiresAt: string } | null;
	} | null;
};

export type SignOutMutationVariables = Exact<{ [key: string]: never }>;

export type SignOutMutation = {
	__typename?: 'RootMutationType';
	signOut?: {
		__typename?: 'SignOutPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| null
		>;
	} | null;
};

export type RecoverPasswordMutationVariables = Exact<{
	input: RecoverPasswordInput;
}>;

export type RecoverPasswordMutation = {
	__typename?: 'RootMutationType';
	recoverPassword?: {
		__typename?: 'RecoverPasswordPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type UpdatePasswordMutationVariables = Exact<{
	input: UpdatePasswordInput;
}>;

export type UpdatePasswordMutation = {
	__typename?: 'RootMutationType';
	updatePassword?: {
		__typename?: 'UpdatePasswordPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type InviteUserMutationVariables = Exact<{
	input: InviteUserInput;
}>;

export type InviteUserMutation = {
	__typename?: 'RootMutationType';
	inviteUser?: {
		__typename?: 'InviteUserPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type AcceptInvitationMutationVariables = Exact<{
	input: AcceptInvitationInput;
}>;

export type AcceptInvitationMutation = {
	__typename?: 'RootMutationType';
	acceptInvitation?: {
		__typename?: 'AcceptInvitationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export const SignInDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'SignIn' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'SignInInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'signIn' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidCredentials' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'result' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'jwt' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } }
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInMutation(
	baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<
	SignInMutation,
	SignInMutationVariables
>;
export const SignOutDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'SignOut' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'signOut' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(
	baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
}
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<
	SignOutMutation,
	SignOutMutationVariables
>;
export const RecoverPasswordDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RecoverPassword' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'RecoverPasswordInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'recoverPassword' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RecoverPasswordMutationFn = Apollo.MutationFunction<
	RecoverPasswordMutation,
	RecoverPasswordMutationVariables
>;

/**
 * __useRecoverPasswordMutation__
 *
 * To run a mutation, you first call `useRecoverPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverPasswordMutation, { data, loading, error }] = useRecoverPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecoverPasswordMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RecoverPasswordMutation,
		RecoverPasswordMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RecoverPasswordMutation, RecoverPasswordMutationVariables>(
		RecoverPasswordDocument,
		options
	);
}
export type RecoverPasswordMutationHookResult = ReturnType<typeof useRecoverPasswordMutation>;
export type RecoverPasswordMutationResult = Apollo.MutationResult<RecoverPasswordMutation>;
export type RecoverPasswordMutationOptions = Apollo.BaseMutationOptions<
	RecoverPasswordMutation,
	RecoverPasswordMutationVariables
>;
export const UpdatePasswordDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'UpdatePassword' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePasswordInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'updatePassword' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<
	UpdatePasswordMutation,
	UpdatePasswordMutationVariables
>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(
	baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(
		UpdatePasswordDocument,
		options
	);
}
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<
	UpdatePasswordMutation,
	UpdatePasswordMutationVariables
>;
export const InviteUserDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'InviteUser' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'InviteUserInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'inviteUser' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type InviteUserMutationFn = Apollo.MutationFunction<
	InviteUserMutation,
	InviteUserMutationVariables
>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(
	baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(
		InviteUserDocument,
		options
	);
}
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<
	InviteUserMutation,
	InviteUserMutationVariables
>;
export const AcceptInvitationDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'AcceptInvitation' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'AcceptInvitationInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'acceptInvitation' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<
	AcceptInvitationMutation,
	AcceptInvitationMutationVariables
>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInvitationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		AcceptInvitationMutation,
		AcceptInvitationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(
		AcceptInvitationDocument,
		options
	);
}
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<
	AcceptInvitationMutation,
	AcceptInvitationMutationVariables
>;
